import React from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'

export default function PorgressivesSection() {
  const { t } = useTranslation(['ui', 'intro'])
  const text = 'intro:sections.progressives'

  const { animation, onPressIn, onPressOut } = useAnimatedPress()

  const onPress = () => router.navigate('/deals?tag=vf')

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/tree-book.png'),
            imageStyle: {
              transform: [{ translateX: 75 }, { translateY: 15 }],
            },
            blur: Platform.select({ default: 125, web: 25 }),
            blurStyle: {
              opacity: 0.5,
              transform: [
                // { translateX: Platform.select({ default: -25, web: -10 }) },
                { translateX: -25 },
                { translateY: 75 },
                { scale: Platform.select({ default: 0.75, web: 0.75 }) },
                { rotate: '-10deg' },
              ],
            },
          }}
        />
      </Pressable>
    </>
  )
}
